import React from "react";
import Topic from "./topic";

const ProjectCaseStudyWrapper = () => {
  const projects = [
    { imgUrl: "assets/img/techex-landing-page/skooltool.webp", head: "MySkooltool", subHead: "School management Software", link: "https://www.myskooltool.com" },
    { imgUrl: "assets/img/techex-landing-page/athaca.webp", head: "ATH Academy", subHead: "ATH academy site", link: "http://academy.abiatechhub.com/" },
    { imgUrl: "assets/img/techex-landing-page/wspace.webp", head: "Workspace", subHead: "Workspace booking app", link: "http://workspace.abiatechhub.com/" },
    { imgUrl: "assets/img/techex-landing-page/ath-pos.webp", head: "Retail POS", subHead: "POS system for OneBS Gadgets", link: "https://pos.onebsgadgets.com/" },
  ];

  return (
    <section className="revamp-projects" style={{marginTop: '60px'}}>
        <div className="container">
            <Topic head={"Our Completed Projects"} info={"We Have Successfully Completed Many IT Solutions Projects"} />
        </div>
        <div className="container">
            <div className="revamp-projects-grid">
                {projects.map((proj, index) => (
                    <a key={index} href={proj.link} target="_blank" rel="noopener noreferrer" className="revamp-project-card">
                        <div className="revamp-project-card__img" style={{backgroundImage: `url(${proj.imgUrl})`}}></div>
                        <div className="revamp-project-card__content">
                            <h3>{proj.head}</h3>
                            <p>{proj.subHead}</p>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    </section>
  );
};

export default ProjectCaseStudyWrapper;